try{self['workbox:range-requests:4.1.1']&&_()}catch(e){}// eslint-disable-line